import React from 'react'

export function LoadingSpinner() {

    return (
        <div className="text-loader">
        <p className="h6-style"> Loading... </p>
        </div>
    );
}